import { createParser, system } from "../core";
import { t } from "../utils";
var config = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true,
  placeItems: true
};
/**
 * Types for grid related CSS properties
 */

export var grid = system(config);
export var gridParser = createParser(config);
//# sourceMappingURL=grid.js.map